module.exports = __webpack_public_path__ + "static/media/full_up_chevron.63915ace.svg";